<template>
  <section-content
    v-if="products.length"
    :title="title"
    :expandable="expandable"
    :expand-on-load="expandOnLoad"
    :column-name="columnName"
  >
    <ul>
      <product
        v-for="(product, index) in products"
        :key="index"
        :item="product"
        :selected-products="selectedProducts"
        :show-purchase-price="showPurchasePrice"
        :is-selected="productIsSelected(product)"
        :show-incl-price="showInclPrice"
        :show-excl-price="showExclPrice"
        @add-to-selected="addToSelected"
        @remove-from-selected="removeFromSelected"
        @product-name-click="productNameClick"
      />
    </ul>
  </section-content>
</template>

<script>
import Product from '@/components/generic/presentational/molecules/product/Product.vue'
import SectionContent from '@/components/generic/presentational/atoms/sectionContent/SectionContent.vue'

export default {
  components: {
    Product,
    SectionContent,
  },
  props: {
    products: {
      type: Array,
      default: () => [],
    },
    selectedProducts: {
      type: Array,
      default: () => [],
    },
    showPurchasePrice: {
      type: Boolean,
      default: false,
    },
    expandable: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: false,
      default: '',
    },
    expandOnLoad: {
      type: Boolean,
      default: false,
    },
    showExclPrice: {
      type: Boolean,
      default: false,
    },
    showInclPrice: {
      type: Boolean,
      default: true,
    },
    columnName: {
      type: String,
      required: false,
      default: '',
    },
  },
  emits: ['product-name-click', 'remove-from-selected', 'add-to-selected'],
  methods: {
    addToSelected(selectedProduct) {
      this.$emit('add-to-selected', selectedProduct)
    },
    removeFromSelected(deselectedProduct) {
      this.$emit('remove-from-selected', deselectedProduct)
    },
    productNameClick(id) {
      this.$emit('product-name-click', id)
    },
    productIsSelected(product) {
      return (
        this.selectedProducts.filter(
          (selectedProduct) => selectedProduct.OptionType_ID === product.OptionType_ID
        ).length > 0
      )
    },
  },
}
</script>

<style lang="scss" scoped></style>
